import { getGlobalStats } from "@dailywars/core/db";
import { UNIT_KINDS, isTransport, type UnitKind } from "@dailywars/core/engine";
import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";

export type GlobalStatsTotals = {
  mapsCleared: number;
  buildingsCaptured: number;
  unitsBuilt: number;
  unitsKilled: number;
  unitsBuiltByKind: Partial<Record<UnitKind, number>>;
  unitsKilledByKind: Partial<Record<UnitKind, number>>;
};

export function shapeGlobalStats(
  record: Awaited<ReturnType<typeof getGlobalStats>>,
): GlobalStatsTotals {
  return {
    mapsCleared: record.gamesCompleted,
    buildingsCaptured: sumPartialRecord(record.buildingsCaptured),
    unitsBuilt: sumPartialRecord(record.unitsBuilt),
    unitsKilled: sumPartialRecord(
      record.unitsKilled,
      UNIT_KINDS.filter((kind) => !isTransport(kind)),
    ),
    unitsBuiltByKind: record.unitsBuilt,
    unitsKilledByKind: record.unitsKilled,
  };
}

function sumPartialRecord(
  record: Partial<Record<string, number>>,
  keys?: readonly string[],
): number {
  let total = 0;
  for (const key of keys ?? Object.keys(record)) {
    const value = record[key];
    if (typeof value === "number") total += value;
  }
  return total;
}

export const loadGlobalStats = createServerFn({ method: "GET" }).handler(async () => {
  setRouteAction("global_stats");
  return shapeGlobalStats(await getGlobalStats());
});
